<template>
  <div v-easyadmin="easyadminId" :id="anchorId" :style="variables" v-if="isContentVisibleToUser()" :class="contentType" stripe-content-player-component>
    <breadcrumb :absolute="false"></breadcrumb>
    <div class="container">
      <div class="row pb-5">
        <div class="col-12 col-lg-3 d-flex d-lg-block justify-content-center">
          <div class="cover bg-cover-center mt-3" :style="{'background-image': getContentResponsiveImageURL('image')}">
            <div class="body d-lg-none d-flex justify-content-center">
              <div class="button-container position-absolute">
                <button class="btn btn-primary" @click="expandedContent = !expandedContent">
                  <i class="fa-solid fa-book-open-cover pr-3"></i>{{ ft("content_player.article_read") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9 d-none d-lg-flex flex-column align-items-start justify-content-center">
          <span class="display-1 mb-5">{{ content.title }}</span>
          <button class="btn btn-primary" @click="expandedContent = !expandedContent">
            <i class="fa-solid fa-book-open-cover pr-3"></i>{{ ft("content_player.article_read") }}
          </button>
        </div>
      </div>
      <div class="row justify-content-center d-lg-none" v-if="content.title">
        <div class="col-12 py-3">
          <h1 class="h2 mb-0">{{content.title}}</h1>
        </div>
      </div>
      <div class="row justify-content-center" v-if="content.description">
        <div class="col-lg-7 py-3" v-html="content.description"></div>
      </div>
      <div class="row justify-content-center pb-5">
        <div class="col-lg-7">
          <div class="d-flex align-items-center text-primary py-3 infos">
            <span class="mr-4"><i class="fa-light fa-clock pr-3"></i>{{ content.reading_time }} min</span>
            <span><i class="fa-light fa-lightbulb-on pr-3"></i>{{ content.key_ideas }} key ideas</span>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row justify-content-center pt-3">
        <div class="col-lg-7">
          <p class="h4 chapters-title">{{ ft("content_player.chapters") }}</p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-7 chapters px-0">
          <ul class="list-unstyled chapters-list mb-0">
            <li 
              v-for="(chapter, index) in content.chapters"
              class="media chapter cursor-pointer px-3"
              @click="expandContentInChapter(index)"
            >
              <span class="chapter-number">{{ index+1 }}</span>
              <div class="media-body px-3">
                <span class="chapter-title">{{ chapter.title }}</span>
              </div>
              <i class="fa-light fa-chevron-right fa-sm"></i>
            </li>
          </ul>
        </div>
      </div>
      <div class="row justify-content-center py-5">
        <div class="col-6 col-md-3 d-flex justify-content-center">
          <button class="btn btn-primary" @click="expandedContent = !expandedContent">
            <i class="fa-solid fa-book-open-cover pr-3"></i>{{ ft("globals.see_content") }}
          </button>
        </div>
      </div>
    </div>
    <stripe-article-interactions
      v-if="content.share"
      class="justify-content-end pt-2"
      :content="content"
      :opt-container-content="containerContent"
    ></stripe-article-interactions>
    <vote-interaction class="py-3" :content="content"></vote-interaction>
    <related-collections :content="content"></related-collections>
    <div class="player bg-light" v-show="expandedContent">
      <stripe-content-player-head 
        :content="content"
        :opt-container-content="optContainerContent"
        :visible="expandedContent"
        :body-expanded="expandedContentBody"
        @visible="backOrToggleExpand"
        @last-slide="value => lastSlide=value"
      >
        <template #player-body>
          <stripe-content-player-body
            class="container" 
            :key="`body-${expandedContent}`"
            :content="content"
            :opt-container-content="optContainerContent"
            :expanded="expandedContentBody" 
            :initial-index="contentBodyIndex"
            :last-slide="lastSlide"
            @expand-content-body="value => expandedContentBody = value"
            @expand-content="value => expandedContent = value">
          </stripe-content-player-body>
        </template>
      </stripe-content-player-head>
    </div>
  </div>
</template>

<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  data: function() {
    return {
      expandedContent: true,
      expandedContentBody: false,
      contentBodyIndex: 0,
      lastSlide: false,
      variables: null
    };
  },
  mounted() {
    const uA = navigator.userAgent;
    this.variables = { "--viewport-height": (/Safari/i.test(uA) && !/Mobi|Android/i.test(uA)) ? "100vh" : "100dvh" };

    if (this.expandedContent) {
      $('body').addClass('overflow-hidden');
    }
  },
  methods:{
    backOrToggleExpand(value) {
      if (document.referrer != '' && window.location.hostname == (new URL(document.referrer).hostname)) {
        history.go(-1);
      } else {
        this.expandedContent = value; 
      }
    },
    expandContentInChapter(contentBodyIndex) {
      this.contentBodyIndex = contentBodyIndex;
      this.expandedContent = true;
      this.expandedContentBody = true;
    }
  },
  watch: {
    expandedContentBody(value) {
      if (value && !!window.wa_gc) {
        const digitalData = Fandom.deepClone(window.digitalData);
        digitalData.link_name = window.truncatedPageName + ":Esplora articolo";
        window.wa_gc(digitalData, "link");
        console.log("%cExecuted wa_gc(digitalData, 'link')", "background: #222; color: #bada55; padding: .5rem;", digitalData);
      }
    },
    expandedContent(value) {
      if (value) {
        $('body').addClass('overflow-hidden');
      } else {
        this.expandedContentBody = false;
        this.contentBodyIndex = 0;
        $('body').removeClass('overflow-hidden');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
[stripe-content-player-component] {
  --navigation-height: 4rem;
  --handle-height: 3.5rem;
  --viewport-height: 100dvh;
  --box-size: 1rem;
  --player-z-index: 1090;

  @include media-breakpoint-down(sm) {
    --box-size: 0px;
  }

  .cover {
    aspect-ratio: 3/4;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: .5rem;

    @include media-breakpoint-down(md) {
      height: 55vh;
      max-height: 500px;
    }

    .button-container {
      bottom: -24px;

      button {
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, .25);
      }
    }
  }

  .infos {
    border-top: 1px solid rgba(0, 0, 0, .25);
    border-bottom: 1px solid rgba(0, 0, 0, .25);
  }

  .chapters-title {
    font-family: 'VodafoneLt';
  }

  .chapters {
    .chapter {
      height: 5rem;
      align-items: center;
      border-top: 1px solid rgba(0, 0, 0, .25);

      &:last-of-type {
        border-bottom: 1px solid rgba(0, 0, 0, .25);
      }

      &-number {
        font-family: 'VodafoneEx';
        font-size: 2rem;
        font-weight: 800;
        color: $primary;
      }

      &-title {
        font-family: 'VodafoneLt';
        @include font-size(1.75rem);
        font-weight: 400;
        line-height: 29px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;  
        overflow: hidden;
      }
    }
  }

  .player {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: var(--player-z-index);
    height: var(--viewport-height);

    .skinned {
      width: 2.5rem;
      height: 2.5rem;
      text-align: center;
      border-radius: 100%;
      background-color: rgba($gray-500, .65);

      i {
        color: $white;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, .5);
        font-size: 18px;
      }
    }
  }

  ::v-deep {
    [vote-interaction-component] {
      background-color: $gray-225;
    }
  }

}
</style>